"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8446],{

/***/ 4847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useImageDataHandler; }
/* harmony export */ });
/* unused harmony export imageDataHandler */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _contexts_ViewportContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9366);
/* harmony import */ var _util_magnolia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7581);
/* harmony import */ var _util_viewport__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5625);





/**
 * Hook to generate an image handler function.
 *
 * Options can be passed to handler function to optimise image size.
 * If the image does not to bigger than "sm" in any viewport, then
 * `maxViewport` option should be set to `Viewport.sm`.
 *
 * Image sizes (width) for each viewport size:
 * - xs: 600px
 * - sm: 800px
 * - md: 900px
 * - lg: 1024px
 * - xl: 1440px
 */ function useImageDataHandler() {
    var isPreview = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().isPreview;
    var viewport = (0,_contexts_ViewportContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().viewport;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(image, options) {
        return imageDataHandler(image, viewport, isPreview, options);
    }, [
        isPreview,
        viewport
    ]);
}
/**
 * Get image information from MGNL (MGNL = Magnolia)
 * @param image - Image object from MGNL
 * @param viewport - Viewport from store
 * @returns Object containing "imageSrc" (image url), "imageLoader" (loader to handle next/image)
 *  and boolean "fallback", to show a fallback image if current image is not published in MGNL
 */ function imageDataHandler(image, viewport) {
    var isPreview = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, options = arguments.length > 3 ? arguments[3] : void 0;
    if (typeof image === "string" || !image) return {
        src: "",
        width: 0,
        height: 0,
        imageLoader: undefined,
        imageSrc: ""
    };
    var _metadata = image.metadata, width = _metadata.width, height = _metadata.height;
    var src = (0,_util_magnolia__WEBPACK_IMPORTED_MODULE_3__/* .formatAssetLink */ .Qz)(image["@link"], isPreview).toString();
    var optimisedViewport = (0,_util_viewport__WEBPACK_IMPORTED_MODULE_4__/* .optimiseViewport */ .s)(viewport, options);
    var imageLoader = function() {
        var ref;
        return optimisedViewport && ((ref = image.renditions) === null || ref === void 0 ? void 0 : ref[optimisedViewport].link) ? (0,_util_magnolia__WEBPACK_IMPORTED_MODULE_3__/* .formatAssetLink */ .Qz)(image.renditions[optimisedViewport].link, isPreview) : src;
    };
    return {
        src: src,
        width: width,
        height: height,
        imageLoader: imageLoader,
        imageSrc: src
    };
}


/***/ }),

/***/ 8446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Masonry_Masonry; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-be3826ec.mjs
var Image_be3826ec = __webpack_require__(567);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Masonry.js
var Masonry = __webpack_require__(3077);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/contexts/SaveItemsToStorageContext.tsx
var SaveItemsToStorageContext = __webpack_require__(2433);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/Masonry/Masonry.tsx










function Masonry_Masonry(props) {
    var rawVariants = props.variants;
    var isPreview = (0,router.useRouter)().isPreview;
    var ref = (0,SaveItemsToStorageContext/* default */.Z)(), isSaved = ref.isSaved, toggleItemInLocalStorage = ref.toggleItemInLocalStorage;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var variants = (0,magnolia/* jcrMultiFieldToArray */.FE)(rawVariants).map(function(variant) {
        if (!("page" in variant)) {
            return {
                linkPreview: mapToLinkPreviewCardProps(variant, isSaved, toggleItemInLocalStorage, imageDataHandler)
            };
        }
        return {
            masonry: mapToMasonryCardProps(variant, isSaved, toggleItemInLocalStorage, isPreview, imageDataHandler)
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Masonry/* MasonryGrid */.e, {
        variants: variants
    });
}
var mapToMasonryCardProps = function(variant, isSaved, toggleSave, isPreview, imageDataHandler) {
    var ref;
    var page = variant.page;
    var title = page.title, description = page.description, introductionImage = page.introductionImage;
    var id = page["@id"];
    var isItemSaved = isSaved(id);
    var imageData = imageDataHandler(introductionImage);
    var imageProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
        altText: title,
        styling: Image_be3826ec.a.MASONRY_CARD,
        credits: introductionImage === null || introductionImage === void 0 ? void 0 : (ref = introductionImage.metadata) === null || ref === void 0 ? void 0 : ref.rights
    });
    return {
        title: title,
        description: description,
        showSaveButton: true,
        link: (0,magnolia/* formatPageLink */.Jd)(page["@path"], isPreview),
        image: imageProps,
        isSaved: isItemSaved,
        onClick: function() {
            var ref;
            toggleSave({
                id: id,
                description: description,
                image: introductionImage,
                pageLink: (ref = page["@link"]) !== null && ref !== void 0 ? ref : "",
                title: title,
                type: "masonryCard"
            });
        }
    };
};
var mapToLinkPreviewCardProps = function(linkPreviewVariant, isSaved, toggleSave, imageDataHandler) {
    var ref;
    if (!linkPreviewVariant.card) {
        return undefined;
    }
    var card = mapToCardProps(linkPreviewVariant.card, isSaved, toggleSave, imageDataHandler);
    return {
        card: card,
        hasSaveButton: linkPreviewVariant.hasSaveButton,
        hasImages: (linkPreviewVariant === null || linkPreviewVariant === void 0 ? void 0 : (ref = linkPreviewVariant.card) === null || ref === void 0 ? void 0 : ref.field) === "image"
    };
};
function mapToCardProps(node, isSaved, toggleSave, imageDataHandler) {
    var ref;
    var image = node.image, cardTitle = node.cardTitle, cardIntroText = node.cardIntroText, link = node.link, altText = node.altText, linkLabel = node.linkLabel, linkDescription = node.linkDescription;
    var id = node["@id"];
    var isItemSaved = isSaved(id);
    if (!image || !altText) {
        return {
            cardTitle: cardTitle,
            cardIntroText: cardIntroText,
            link: link,
            linkLabel: linkLabel,
            linkDescription: linkDescription,
            isSaved: isItemSaved,
            onSave: function() {
                toggleSave({
                    id: id,
                    linkLabel: linkLabel,
                    linkDescription: linkDescription,
                    pageLink: link,
                    description: cardIntroText,
                    title: cardTitle,
                    altText: altText,
                    type: "linkPreviewCard"
                });
            }
        };
    }
    var imageData = imageDataHandler(image, {
        maxViewport: app/* Viewport.sm */.l_.sm
    });
    var imageProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
        altText: altText,
        credits: image === null || image === void 0 ? void 0 : (ref = image.metadata) === null || ref === void 0 ? void 0 : ref.rights
    });
    return {
        cardTitle: cardTitle,
        cardIntroText: cardIntroText,
        link: link,
        linkLabel: linkLabel,
        linkDescription: linkDescription,
        imageProps: imageProps,
        // image,
        isSaved: isItemSaved,
        onSave: function() {
            toggleSave({
                id: id,
                image: image,
                pageLink: link,
                title: cardTitle,
                description: cardIntroText,
                type: "linkPreviewCard"
            });
        }
    };
}

;// CONCATENATED MODULE: ./src/magnolia/components/Masonry/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 3077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ he; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(403);
/* harmony import */ var _app_51178863_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7610);
/* harmony import */ var _LinkPreviewCard_7d4ab2b6_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8775);
/* harmony import */ var _Link_460da2fc_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1607);
/* harmony import */ var _Image_be3826ec_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(567);
/* harmony import */ var _Button_eec2778c_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9358);
/* harmony import */ var _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7720);












function T(a, t) {
  if (a == null)
    return {};
  var e = A(a, t), n, r;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(a);
    for (r = 0; r < s.length; r++)
      n = s[r], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(a, n) && (e[n] = a[n]);
  }
  return e;
}
function A(a, t) {
  if (a == null)
    return {};
  var e = {}, n = Object.keys(a), r, s;
  for (s = 0; s < n.length; s++)
    r = n[s], !(t.indexOf(r) >= 0) && (e[r] = a[r]);
  return e;
}
function b() {
  return b = Object.assign || function(a) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
    }
    return a;
  }, b.apply(this, arguments);
}
function k(a, t) {
  var e = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(a);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(a, r).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function y(a) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? k(Object(e), !0).forEach(function(n) {
      G(a, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(e)) : k(Object(e)).forEach(function(n) {
      Object.defineProperty(a, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }
  return a;
}
function G(a, t, e) {
  return t in a ? Object.defineProperty(a, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : a[t] = e, a;
}
const M = {
  breakpointCols: void 0,
  // optional, number or object { default: number, [key: number]: number }
  className: void 0,
  // required, string
  columnClassName: void 0,
  // optional, string
  // Any React children. Typically an array of JSX items
  children: void 0,
  // Custom attributes, however it is advised against
  // using these to prevent unintended issues and future conflicts
  // ...any other attribute, will be added to the container
  columnAttrs: void 0,
  // object, added to the columns
  // Deprecated props
  // The column property is deprecated.
  // It is an alias of the `columnAttrs` property
  column: void 0
}, v = 2;
class _ extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(t) {
    super(t), this.reCalculateColumnCount = this.reCalculateColumnCount.bind(this), this.reCalculateColumnCountDebounce = this.reCalculateColumnCountDebounce.bind(this);
    let e;
    this.props.breakpointCols && this.props.breakpointCols.default ? e = this.props.breakpointCols.default : e = parseInt(this.props.breakpointCols) || v, this.state = {
      columnCount: e
    };
  }
  componentDidMount() {
    this.reCalculateColumnCount(), window && window.addEventListener("resize", this.reCalculateColumnCountDebounce);
  }
  componentDidUpdate() {
    this.reCalculateColumnCount();
  }
  componentWillUnmount() {
    window && window.removeEventListener("resize", this.reCalculateColumnCountDebounce);
  }
  reCalculateColumnCountDebounce() {
    if (!window || !window.requestAnimationFrame) {
      this.reCalculateColumnCount();
      return;
    }
    window.cancelAnimationFrame && window.cancelAnimationFrame(this._lastRecalculateAnimationFrame), this._lastRecalculateAnimationFrame = window.requestAnimationFrame(() => {
      this.reCalculateColumnCount();
    });
  }
  reCalculateColumnCount() {
    const t = window && window.innerWidth || 1 / 0;
    let e = this.props.breakpointCols;
    typeof e != "object" && (e = {
      default: parseInt(e) || v
    });
    let n = 1 / 0, r = e.default || v;
    for (let s in e) {
      const l = parseInt(s);
      l > 0 && t <= l && l < n && (n = l, r = e[s]);
    }
    r = Math.max(1, parseInt(r) || 1), this.state.columnCount !== r && this.setState({
      columnCount: r
    });
  }
  itemsInColumns() {
    const t = this.state.columnCount, e = new Array(t), n = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(this.props.children);
    for (let r = 0; r < n.length; r++) {
      const s = r % t;
      e[s] || (e[s] = []), e[s].push(n[r]);
    }
    return e;
  }
  renderColumns() {
    const {
      column: t,
      columnAttrs: e = {},
      columnClassName: n
    } = this.props, r = this.itemsInColumns(), s = `${100 / r.length}%`;
    let l = n;
    l && typeof l != "string" && (this.logDeprecated('The property "columnClassName" requires a string'), typeof l > "u" && (l = "my-masonry-grid_column"));
    const i = y(y(y({}, t), e), {}, {
      style: y(y({}, e.style), {}, {
        width: s
      }),
      className: l
    });
    return r.map((u, c) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", b({}, i, {
      key: c
    }), u));
  }
  logDeprecated(t) {
    console.error("[Masonry]", t);
  }
  render() {
    const t = this.props, {
      // ignored
      children: e,
      breakpointCols: n,
      columnClassName: r,
      columnAttrs: s,
      column: l,
      // used
      className: i
    } = t, u = T(t, ["children", "breakpointCols", "columnClassName", "columnAttrs", "column", "className"]);
    let c = i;
    return typeof i != "string" && (this.logDeprecated('The property "className" requires a string'), typeof i > "u" && (c = "my-masonry-grid")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", b({}, u, {
      className: c
    }), this.renderColumns());
  }
}
_.defaultProps = M;
const H = "masonry-grid", F = "desktop", W = "masonry-grid__column", $ = "masonry-grid__card-container", U = "masonry-card__image-container", h = {
  masonryGrid: H,
  desktop: F,
  masonryGridColumn: W,
  masonryGridCardContainer: $,
  masonryCardImageContainer: U
}, q = "masonry-card", R = "masonry-card__title", z = "masonry-card__image-container", K = "masonry-card--pressed", J = "desktop", Q = "masonry-card__save-button", V = "masonry-card__save-button--hidden", X = "masonry-card__info", Y = "masonry-card__date", Z = "masonry-card__date--hidden", ee = "masonry-card__title--hidden", te = "masonry-card__description", ne = "masonry-card__description--hidden", d = {
  masonryCard: q,
  masonryCardTitle: R,
  masonryCardImageContainer: z,
  masonryCardPressed: K,
  desktop: J,
  masonryCardSaveButton: Q,
  masonryCardSaveButtonHidden: V,
  masonryCardInfo: X,
  masonryCardDate: Y,
  masonryCardDateHidden: Z,
  masonryCardTitleHidden: ee,
  masonryCardDescription: te,
  masonryCardDescriptionHidden: ne
}, re = ({
  title: a,
  description: t,
  date: e,
  link: n,
  linkLocale: r,
  showSaveButton: s = !1,
  isSaved: l = !1,
  image: i,
  onClick: u
}) => {
  const [c, p] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Link_460da2fc_mjs__WEBPACK_IMPORTED_MODULE_1__.L,
    {
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
        d.masonryCard,
        c && d.masonryCardPressed
      ),
      href: n,
      locale: r,
      "data-testid": "masonry-card",
      disableLinkTextStyle: !0,
      onMouseDown: () => p(!0),
      onMouseUp: () => p(!1),
      onMouseLeave: () => p(!1)
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(d.masonryCardImageContainer),
        "data-testid": "masonry-image"
      },
      i && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        _Image_be3826ec_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
        {
          credits: i.credits,
          src: i.src,
          width: i.width,
          height: i.height,
          altText: i.altText,
          imageLoader: i.imageLoader,
          styling: i.styling
        }
      ),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "div",
        {
          className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
            d.masonryCardSaveButton,
            !s && d.masonryCardSaveButtonHidden
          )
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          _Button_eec2778c_mjs__WEBPACK_IMPORTED_MODULE_4__.B.Save,
          {
            iconFilled: l,
            onMouseDown: (C) => C.stopPropagation(),
            "data-testid": "masonry-save-button",
            onClick: (C) => {
              C?.preventDefault(), u?.();
            }
          }
        )
      )
    ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(d.masonryCardInfo),
        "data-testid": "masonry-content"
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "p",
        {
          className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
            d.masonryCardDate,
            _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadText,
            e === void 0 && d.masonryCardDateHidden
          )
        },
        `Date ${e}`
      ),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: d.masonryCardTitle }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsComponentTitleBold }, a)),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "p",
        {
          className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
            d.masonryCardDescription,
            _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadText
          )
        },
        t
      )
    ))
  );
}, ae = {
  default: 2,
  [_app_51178863_mjs__WEBPACK_IMPORTED_MODULE_5__.D.md - 1]: 1
};
function he(a) {
  const { variants: t } = a;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_6__.B,
    {
      "data-testid": "masonry-block",
      topPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_6__.B.Padding.NONE,
      bottomPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_6__.B.Padding.LARGE
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_6__.B.Content, { "data-testid": "masonry-content" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _,
      {
        breakpointCols: ae,
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(h.masonryGrid),
        columnClassName: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(h.masonryGridColumn),
        "data-testid": "masonry"
      },
      t && t.length && t.map((e, n) => {
        const { masonry: r, linkPreview: s } = e;
        if (r && r.link)
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "div",
            {
              key: n,
              className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(h.masonryGridCardContainer)
            },
            /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(re, { ...r })
          );
        if (s) {
          const { card: l, hasImages: i, hasSaveButton: u } = s, {
            cardIntroText: c,
            cardTitle: p,
            imageProps: C,
            link: w,
            linkLabel: D,
            linkLocale: O,
            linkDescription: P,
            onSave: E,
            isSaved: N
          } = l;
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            "div",
            {
              className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(h.masonryGridCardContainer),
              key: l.link
            },
            /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
              _LinkPreviewCard_7d4ab2b6_mjs__WEBPACK_IMPORTED_MODULE_7__.L,
              {
                key: w,
                cardIntroText: c,
                cardTitle: p,
                imageProps: C,
                link: w,
                linkDescription: P,
                linkLocale: O,
                hasImages: i,
                hasSaveButton: u,
                linkLabel: D,
                onSave: E,
                isSaved: N
              }
            )
          );
        }
      })
    ))
  );
}

//# sourceMappingURL=Masonry.js.map


/***/ }),

/***/ 8775:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ae; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(403);
/* harmony import */ var _Image_be3826ec_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(567);
/* harmony import */ var _Link_460da2fc_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1607);
/* harmony import */ var _Button_eec2778c_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9358);
/* harmony import */ var _CallToAction_855b5705_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5257);






const T = "link-preview-card", B = "desktop", x = "image-container", E = "image", W = "badge", P = "link-wrapper", f = "preview-container", y = "preview-content", H = "card-title", A = "card-intro-text", M = "preview-link", O = "cta-hover", _ = "save-button-container", R = "cta", D = "no-images-card", F = "no-images-preview-content", V = "no-images-card-link-wrapper", j = "no-save-no-images-button-card-height", q = "no-save-button-card-link-wrapper", z = "no-save-no-images-link-wrapper", G = "no-save-button-preview-content", J = "no-save-button-cta", K = "hide-cta-on-mobile", e = {
  linkPreviewCard: T,
  desktop: B,
  imageContainer: x,
  image: E,
  badge: W,
  linkWrapper: P,
  previewContainer: f,
  previewContent: y,
  cardTitle: H,
  cardIntroText: A,
  previewLink: M,
  ctaHover: O,
  saveButtonContainer: _,
  cta: R,
  noImagesCard: D,
  noImagesPreviewContent: F,
  noImagesCardLinkWrapper: V,
  noSaveNoImagesButtonCardHeight: j,
  noSaveButtonCardLinkWrapper: q,
  noSaveNoImagesLinkWrapper: z,
  noSaveButtonPreviewContent: G,
  noSaveButtonCta: J,
  hideCtaOnMobile: K
};
function ae(l) {
  const {
    cardTitle: i,
    cardIntroText: d,
    link: m,
    linkLabel: s,
    linkLocale: v,
    imageProps: t,
    hasImages: n,
    hasSaveButton: o,
    showCTAOnMobile: p = !0,
    newTab: c = !0,
    onSave: k,
    isSaved: w,
    badge: C
  } = l, u = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.linkPreviewCard, {
    [e.noImagesCard]: !n,
    [e.noSaveNoImagesButtonCardHeight]: !o && !n,
    [e.hideCtaOnMobile]: !p
  }), I = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.linkWrapper, {
    [e.noImagesCardLinkWrapper]: !n,
    [e.noSaveButtonCardLinkWrapper]: !o,
    [e.noSaveNoImagesLinkWrapper]: !n && !o
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: u, "data-testid": "link-preview-container" }, n && t && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.imageContainer }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Image_be3826ec_mjs__WEBPACK_IMPORTED_MODULE_2__.I,
    {
      credits: t.credits,
      src: t.src,
      width: t.width,
      height: t.height,
      altText: t.altText,
      imageLoader: t.imageLoader,
      className: e.image,
      styling: _Image_be3826ec_mjs__WEBPACK_IMPORTED_MODULE_2__.a.PREVIEW_CARD,
      "data-testid": "link-preview-image"
    }
  ), C && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.badge, "data-testid": "link-preview-badge" }, C)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: I }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Link_460da2fc_mjs__WEBPACK_IMPORTED_MODULE_3__.L,
    {
      href: m,
      locale: v,
      "aria-label": i,
      disableLinkTextStyle: !0,
      className: e.previewLink,
      target: c ? "_blank" : void 0,
      "data-testid": "link-preview-link"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.previewContainer, "aria-hidden": "true" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      Q,
      {
        cardIntroText: d,
        cardTitle: i,
        linkLabel: s,
        hasImages: n,
        hasSaveButton: o,
        newTab: c
      }
    ))
  ), o && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Button_eec2778c_mjs__WEBPACK_IMPORTED_MODULE_4__.B.Save,
    {
      onClick: k,
      iconFilled: w,
      containerClassName: e.saveButtonContainer,
      "data-testid": "link-preview-save"
    }
  )));
}
const Q = (l) => {
  const { cardIntroText: i, cardTitle: d, hasImages: m, hasSaveButton: s, linkLabel: v, newTab: t } = l, n = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.previewContent, {
    [e.noImagesPreviewContent]: !m,
    [e.noSaveButtonPreviewContent]: !s
  }), o = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsComponentTitleBold,
    e.cardTitle
  ), p = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsBodyText,
    e.cardIntroText
  ), c = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    e.cta,
    e.ctaHover,
    s ? "" : e.noSaveButtonCta
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: n, "data-testid": "link-preview" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("h3", { className: o }, d), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: p }, i), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _CallToAction_855b5705_mjs__WEBPACK_IMPORTED_MODULE_5__.C,
    {
      containerClassName: c,
      as: "div",
      text: v,
      showCTAIcon: t
    }
  ));
};

//# sourceMappingURL=LinkPreviewCard-7d4ab2b6.mjs.map


/***/ })

}]);